/**
 * Convert an Umbraco content url into a public, locale-prefixed path.
 *
 * Umbraco stores page urls under "/one-central/...". The public site serves
 * them under the language segment ("/en/..." or "/ar/..."). This helper is the
 * single source of truth for that rewrite so links never leak raw CMS paths
 * ("/one-central/...") or broken template output ("/$/...").
 *
 * Guards:
 *  - missing/empty url      -> '#0' (a safe, non-navigating anchor)
 *  - missing/invalid lang   -> defaults to 'en'
 *  - url without the prefix  -> returned as-is (already a clean path/external)
 *
 * @param {string|null|undefined} url   The raw url from the CMS.
 * @param {string|null|undefined} lang  'en' | 'ar' (anything else -> 'en').
 * @returns {string} A safe href.
 */
export default function replaceUrl(url, lang) {
  if (!url || typeof url !== 'string') {
    return '#0';
  }

  const langCode = lang === 'ar' ? 'ar' : 'en';

  // Home node is exactly "/one-central" -> "/en" (or "/ar").
  if (url === '/one-central' || url === '/one-central/') {
    return `/${langCode}`;
  }

  // Sub-pages: rewrite the prefix and drop any trailing slash.
  if (url.startsWith('/one-central/')) {
    return url.replace('/one-central/', `/${langCode}/`).replace(/\/$/, '');
  }

  // Already-clean internal paths or external/absolute urls pass through.
  return url;
}
